<div class="mat-drawer-inner-container" cdkScrollable>
  <ng-content></ng-content>
</div>
